var uiCursorPagination = {
	caption: "Cursor-Seitenwechsel",
	first: "Erste Seite",
	previous: "Vorherige Seite",
	next: "Nächste Seite"
};
var de = {
	uiCursorPagination: uiCursorPagination
};

export { de as default, uiCursorPagination };
